
var sprite = require("C:/git/annenberg-petspace-petbook/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 10.55 10.55\" id=\"x\" ><title>Asset 3</title><g data-name=\"Layer 2\"><g data-name=\"Layer 1\"><path d=\"M9.68 10.55a.87.87 0 0 1-.62-.26l-8.8-8.8A.88.88 0 0 1 1.49.26l8.8 8.8a.88.88 0 0 1-.62 1.49z\"/><path d=\"M.87 10.55a.88.88 0 0 1-.61-1.49l8.8-8.8a.88.88 0 1 1 1.24 1.23l-8.8 8.8a.87.87 0 0 1-.63.26z\"/></g></g></symbol>";
module.exports = sprite.add(image, "x");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/x.svg
// module id = 312
// module chunks = 1